import { is } from "../type-guards";

import { SiError, errorCategoryMap } from "./types";

type AssertDefinedOptions = {
    name: string;
    component?: string;
    operation?: string;
};

function assertDefined<T>(
    value: T | null | undefined,
    { name, component, operation }: AssertDefinedOptions,
): asserts value is T {
    if (is.undefined(value) || value === null) {
        throw new SiError(`${name} is required, actual value is ${String(value)}`, {
            category: errorCategoryMap.validation,
            component,
            operation,
        });
    }
}

function assertNever(value: never, context: string, component?: string): never {
    throw new SiError(`Unhandled case: ${String(value)}`, {
        category: errorCategoryMap.invariant,
        component,
        operation: context,
    });
}

function assertCondition(condition: boolean, message: string, component?: string): asserts condition {
    if (!condition) {
        throw new SiError(message, {
            category: errorCategoryMap.validation,
            component,
        });
    }
}

export { assertDefined, assertNever, assertCondition };
